import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { useState, useEffect, useRef } from 'react';
import { DEFAULT_NOTIFICATION_OPTIONS } from './use-notifications.constants';
export default function useNotifications() {
  var initialNotifications = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var finalOptions = _objectSpread(_objectSpread({}, DEFAULT_NOTIFICATION_OPTIONS), {}, {
    options: options
  });
  var allowDuplicates = finalOptions.allowDuplicates,
    autoRemove = finalOptions.autoRemove,
    autoRemoveInterval = finalOptions.autoRemoveInterval;
  var _useState = useState(initialNotifications),
    _useState2 = _slicedToArray(_useState, 2),
    notifications = _useState2[0],
    setNotifications = _useState2[1];
  var autoRemoveTimer = useRef(null);
  function addNotification(message) {
    setNotifications(function (previousNotifications) {
      return [].concat(_toConsumableArray(previousNotifications.filter(function (notificationMessage) {
        return notificationMessage !== message || allowDuplicates;
      })), [message]);
    });
  }
  function removeNotification() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    setNotifications(function (previousNotifications) {
      if (!message) {
        return previousNotifications.slice(1);
      }
      return previousNotifications.filter(function (notificationMessage) {
        return notificationMessage !== message;
      });
    });
  }
  function clearNotifications() {
    setNotifications([]);
  }
  function clearAutoRemoveInterval() {
    if (autoRemoveTimer.current) {
      clearInterval(autoRemoveTimer.current);
      autoRemoveTimer.current = null;
    }
  }
  function startAutoRemoveInterval() {
    clearAutoRemoveInterval();
    if (autoRemove) {
      autoRemoveTimer.current = setInterval(removeNotification, autoRemoveInterval);
    }
  }
  useEffect(function () {
    startAutoRemoveInterval();
    return function () {
      return clearAutoRemoveInterval();
    };
  }, [autoRemove]);
  return {
    notifications: notifications,
    addNotification: addNotification,
    removeNotification: removeNotification,
    clearNotifications: clearNotifications
  };
}